module.exports = __webpack_public_path__ + "img/full5-min.e23134f6.png";